"use client";

import React from "react";
import { Linkedin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const employees = [{
  name: "Marcus Thorne",
  position: "Lead Growth Operator",
  bio: "15+ years scaling B2B platforms from seed to Series C. Focus: Go-to-market architecture, revenue systems, and sustainable growth modeling.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1622697/img/team_jane_doe.png",
  linkedin: "#"
}, {
  name: "Sloane Chen",
  position: "Operations Architect",
  bio: "Specialist in lean infrastructure and founder-burnout reduction. Focus: Operational efficiency, executive workflows, and organizational design.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1622697/img/team_john_smith.png",
  linkedin: "#"
}, {
  name: "Julian Vance",
  position: "Execution Lead",
  bio: "Former product lead at high-growth technology firms. Focus: Rapid prototyping, product-market fit validation, and technical delivery management.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1622697/img/team_elena_rodriguez.png",
  linkedin: "#"
}, {
  name: "Elena Rossi",
  position: "Strategic Advisor",
  bio: "Expertise in private equity and corporate governance. Focus: Capital structuring, board advisory, and preparing ventures for institutional exit.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1622697/img/team_david_kim.png",
  linkedin: "#"
}];
export default function TheArchitects() {
  const {
    headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll();
  const {
    gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll();
  return <section data-section-id="1373" id="the-operators" className="dark bg-background text-foreground py-24 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary/10 to-transparent" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary/10 to-transparent" />
      
      <div className="container mx-auto px-4 md:px-6">
        {}
        <div ref={headerRef} className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-700 transform ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="text-4xl md:text-5xl font-default font-medium tracking-tight mb-6">
            The <span className="text-primary">Operators</span>
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl leading-relaxed font-default">
            A collective of seasoned leaders with a bias for execution. We provide the 
            strategic support and operational rigor required to scale with confidence.
          </p>
        </div>

        {}
        <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {employees.map((member, i) => <div key={member.name} data-index={i} className={`group relative transition-all duration-700 transform ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
          transitionDelay: `${i * 100}ms`
        }}>
              <Card className="h-full bg-card/30 border-border/40 backdrop-blur-sm overflow-hidden hover:border-primary/40 transition-colors duration-500 rounded-sm">
                {}
                <div className="relative aspect-[4/5] overflow-hidden bg-muted">
                  <img src={member.image} alt={`${member.name} - ${member.position}`} className="w-full h-full object-cover transition-all duration-700 ease-out filter grayscale contrast-125 group-hover:grayscale-0 group-hover:contrast-100 group-hover:scale-105" />
                  {}
                  <div className="absolute inset-0 bg-primary/20 mix-blend-color pointer-events-none transition-opacity duration-500 group-hover:opacity-0" />
                  
                  {}
                  <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                </div>

                {}
                <CardContent className="p-6 relative flex flex-col h-auto min-h-[180px]">
                  <div className="mb-4">
                    <h3 className="text-xl font-default font-medium text-foreground group-hover:text-primary transition-colors duration-300">
                      {member.name}
                    </h3>
                    <p className="text-primary/70 font-mono text-xs uppercase tracking-widest mt-1">
                      {member.position}
                    </p>
                  </div>
                  
                  <p className="text-muted-foreground text-sm leading-relaxed line-clamp-3 mb-6 font-default">
                    {member.bio}
                  </p>

                  {}
                  <div className="absolute bottom-4 right-4">
                    <Link to={member.linkedin} target="_blank" className="inline-flex items-center justify-center w-8 h-8 rounded-sm bg-background/40 hover:bg-primary hover:text-primary-foreground text-muted-foreground transition-all duration-300 border border-border/40 hover:border-primary" aria-label={`LinkedIn profile of ${member.name}`}>
                      <Linkedin className="w-4 h-4" />
                    </Link>
                  </div>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}